import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import * as types from "@/store/constants/types";
import { i18n } from "@/i18n/i18n-setup";
import EventBus from "@/utils/eventBus";
import { sendMapEvent } from "@/utils/analytics";

var actions = _defineProperty({}, types.SHOW_VIP_TOAST, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref, payLoad) {
    var state, commit, getters, dispatch, pointPic, data, launchConfig;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, getters = _ref.getters, dispatch = _ref.dispatch;

            try {
              pointPic = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAARVBMVEUAAAAQ43AS43IR43IR43IS43IQ33AQ5HAR43IQ33AS43IR43IS4nES43ER5HIQ5HEQ5HAS5HIR4nMR43EQ43AQ43AS43JfDiCTAAAAFnRSTlMAIN/e74AQMc4gf66fj3BfMJ9QvkA/GNuaVwAAANZJREFUSMft1MsOgyAQheEBhHq/tT3v/6hNTCY2VQRnFt3wr/0WqBwqlUpcaC0qI7OPCsCksF5ha4V1Rm7xUlivsJ3IGgs+sNBCY0eFHRTWaWz0wKFJWawUaa5g52vrY7bZHhiv7JNi9dhqz23i77BgHbGYKYnRhaNNXYcRXG3O7EJXeXDWHK0LlKsfP5bHMktX67flsczV8Gz5E9zTbPPHctj1wjZ/O3ocexNJNB9YpG+PZaiZ8YHlmq1AC8YyOADisWzcfh0kml+WWE8krBm6iUql//YBvVAhLepVVU0AAAAASUVORK5CYII=";
              data = {
                show: true,
                topImg: require("@/assets/icons/toast/vip_free_ends_today.png"),
                title: i18n.t("vip_center_page.close_toast.title"),
                titleColor: "linear-gradient(to right, rgb(93,53,254), rgb(251,41,142))",
                content: "\n          <ul>\n            <li class=\"flex\" style=\"margin-bottom:12px\">\n              <img style=\"width:14px;margin-right:10px\" src=\"".concat(pointPic, "\">\n              <p style=\"font-size:14px;line-height:18px;text-align:left\">").concat(i18n.t("vip_center_page.close_toast.text_array[0]"), "</p>\n            </li>\n            <li class=\"flex\" style=\"margin-bottom:12px\">\n              <img style=\"width:14px;margin-right:10px\" src=\"").concat(pointPic, "\">\n              <p style=\"font-size:14px;line-height:18px;text-align:left\">").concat(i18n.t("vip_center_page.close_toast.text_array[1]"), "</p>\n            </li>\n            <li class=\"flex\" style=\"margin-bottom:12px\">\n              <img style=\"width:14px;margin-right:10px\" src=\"").concat(pointPic, "\">\n              <p style=\"font-size:14px;line-height:18px;text-align:left\">").concat(i18n.t("vip_center_page.close_toast.text_array[2]"), "</p>\n            </li>\n        </ul>\n  \n        "),
                confirmNotClose: true,
                showCloseBtn: true,
                isFuseAnimate: true,
                clickAllBtn: true,
                vipConfirmBtn: true
              };
              data.confirmFn = payLoad.confirmFn;
              data.cancelFn = payLoad.cancelFn;
              launchConfig = getters[types.GETTER_LAUNCH_CONFIG];

              if (launchConfig && launchConfig.vip_before_unload && launchConfig.vip_before_unload === "full_page") {
                //大的全屏toast，直接用路由来控制:
                dispatch(types.ROUTER_REPLACE, {
                  name: "vipFullToast",
                  params: {
                    routerTransition: "static"
                  }
                });
              } else {
                //小的toast
                EventBus.$emit("vip-toast-show", data);
                sendMapEvent('uia_vip_before_unload_dialog', {
                  key: 'show'
                });
              }
            } catch (e) {}

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());

export default actions;